import { AnswerAreaContentSwitch, usePinContext } from '@lessonup/pin-renderer';
import { isTeacherPin } from '@lessonup/pins-shared';
import React from 'react';
import { OpenQuestionAnswerAreaContentEditor } from './OpenQuestionAnswerAreaContentEditor';
import { PollAnswerAreaContentEditor } from './PollAnswerAreaContentEditor';
import { SortingQuestionAnswerAreaContentEditor } from './SortingQuestionAnswerArea/SortingQuestionAnswerAreaContentEditor';

interface AnswerAreaContentSwitchEditorProps {
  isPinComponentActive?: boolean;
  editable: boolean;
  scale?: number;
  isInteractive?: boolean;
}

export function AnswerAreaContentSwitchEditor({
  isPinComponentActive,
  editable,
  scale,
  isInteractive = false,
}: AnswerAreaContentSwitchEditorProps) {
  const pin = usePinContext();

  if (!isTeacherPin(pin)) {
    throw new Error('AnswerAreaContentSwitchEditor can only be used with a TeacherPin');
  }

  switch (pin.type) {
    case 'OPEN_QUESTION':
      return (
        <OpenQuestionAnswerAreaContentEditor
          pin={pin}
          isPinComponentActive={isPinComponentActive}
          showPlaceholderCards={editable}
        />
      );
    case 'SORTING_QUESTION':
      return (
        <SortingQuestionAnswerAreaContentEditor
          isPinComponentActive={isPinComponentActive}
          pin={pin}
          scale={scale}
          isInteractive={isInteractive}
        />
      );
    case 'POLL':
      return <PollAnswerAreaContentEditor pin={pin} isInteractive={isInteractive} />;
    default:
      return <AnswerAreaContentSwitch isInteractive={isInteractive} />;
  }
}
